const MESSAGES = {
  OTPSent: "Otp has been sent to mail",
  Include_users_who_have_been_disabled: "Include users who have been disabled",
  LOGIN_FAILED: "Login Failed",
  Roles_Select_Role_As_Agreed_By_Headteacher: "Roles - Select Role(s) as agreed by Headteacher",
  Classes_Select_Classes_That_This_User_Will_Be_Teaching_Or_Supporting: "Classes - Select Classes that this user will be teaching or supporting",
  This_Combination_Already_Exists: "This combination Already Exists",
  No_Invitation_Found: "No invitation found",
  Please_Enter_Otp_Sent: "Please Enter Otp sent to your mail",
  Please_Enter_Your_Email_Address: "Please Enter your email address",
  Please_Move_ALL_Pupil_Before_Delete: "Please Move all pupil before deleting the class",
};
const VALIDATION = {
  COMMENT_IS_REQUIRED: "comment is required!",
  CONFIRM_PASSWORD_IS_REQUIRED: "Confirm Password is Required",
  EMAIL_IS_REQUIRED: "Email is required",
  EMAIL_MUST_MATCH: "Email must match",
  EMPTY_SPACE_NOT_ALLOWED: "Empty spaces not allowed!",
  FIRST_NAME_IS_REQUIRED: "First name is required!",
  IS_NUMBER: "is-number",
  IS_POSITIVE: "Is positive?",
  LAST_NAME_IS_REQUIRED: "Last name is required!",
  MarksUpdated: "marks successfully updated!",
  MUST_BE_A_NUMBER: "OTP must be a number",
  MUST_BE_A_VALID_EMAIL_ADDRESS: "Must be a valid email address",
  NAME_CANT_BE_LONGER_THAN_50_CHARACTERS: "*Name can't be longer than 50 characters",
  NAME_CANT_BE_LONGER_THAN_100_CHARACTERS: "*Name can't be longer than 100 characters",
  NAME_IS_REQUIRED: "Name is required",
  NAME_MUST_HAVE_AT_LEAST_2_CHARACTERS: "*Names must have at least 2 characters",
  NAME_SHOULD_CONTAIN_ATLEAST_2_CHARACTERS: "Names should contain atleast 2 characters",
  NUMBERS_ARE_NOT_ALLOWED_FOR_USERNAME: "Username should contain only alphabets!",
  OLD_PASSWORD_IS_REQUIRED: "Old password is required",
  OTP_IS_REQUIRED: "*OTP is required",
  OTP_MUST_HAVE_6_CHARACTERS: "*Otp must have 6 digits",
  OTP_MUST_HAVE_6_DIGITS: "*Otp must contain only 6 digits",
  PASSWORD_MUST_HAVE_AT_LEAST_ONE_UPPERCASE_LOWERCASE_NUMBER_SPECAIL_CHARACTER: "*Password must have at least one uppercase letter, one lowercase letter, one number and one special character",
  PASSWORD_MUST_HAVE_MINIMUM_8_CHARACTERS: "*Password must have minimum 8 characters",
  PASSWORD_MUST_MATCH: "Passwords must match",
  PHONE_NUMBER_CANNOT_BE_EMPTY: "Phone number cannot be empty!",
  PLEASE_CONFIRM_THE_PASSWORD: "Please confirm the password",
  PLEASE_SELECT_A_SUBJECT: "Please Select Subject",
  PLEASE_SELECT_A_CLASS: "Please Select Class",
  PLEASE_SELECT_A_ROLE: "Please Select Role",
  PLEASE_ENTER_VALID_EMAIL_ADDRESS: "Please enter a valid email",
  SCHOOL_ID_IS_REQUIRED: "School ID is required",
  SCHOOL_Name_IS_REQUIRED: "School Name is required",
  SELECT_ANY_ONE: "Select any one",
  SUCCESSFULLY_APPLIED: "Successfully Applied",
  SUCCESSFULLY_REVERTED: "Successfully Reverted",
  SUCCESSFULLY_UPDATED: "Successfully Updated",
  USER_IS_ALREADY_DISABLED_DO_YOU_WANT_TO_DELETE_THE_ROLE: "User is Already Disabled Do you want to delete the Role",
  USER_IS_ALREADY_DISABLED_DO_YOU_WANT_TO_DELETE_THE_CLASS: "User is Already Disabled Do you want to delete the Class",
  WONDE_SCHOOL_ID_IS_REQUIRED: "Wonde School ID is required",
  YOUR_ROLE_IS_REQUIRED: "*Your Role is required",
}
const ERROR = {
  ACCESS_DENIED: "Session Expired, Please Login Again",
  FETCHING_DATA: "Sorry, there was a problem trying to fetch data.",
  IMPORT_ERROR: "The Import couldn't be initiated. Please try again after some time",
  MAXIMUM_4_SUBJECT: "Maximum 4 additional subjects can be added.",
  PLEASE_SELECT_FILE_FORMAT: "Please select only .xlsx files",
  PAGE_NOT_FOUND: "Page Not Found",
  REPORT_NOT_SAVED: "Report Not Saved",
  SUBJECT_NAME_REQUIRED_FOR_ADDITIONAL_SUBJECT: "Subject name is required for all additional subjects.",
  UPDATE: "Sorry, there was a problem trying to perform the update. Your changes are not saved.",
}

const SUCCESS = {
  ACADEMIC_DETAILS_UPDATED: "Academic details updated successfully",
  ACCESS_REQUESTED_WAITING_FOR_APPROVAL: "Access requested for approval",
  ASSESSMENT_DELETED_SUCCESSFULLY: "Assessment Deleted Successfully!",
  ASSESSMENT_SAVED: "Assessment Saved Successfully",
  ASSESSMENT_SUBMITTED: "Assessment Submitted. Further Changes are not Allowed",
  BASELINE_DATA_SUBMITTED: "Baseline data submitted",
  CLASS_CREATED: "Class Created Successfully!",
  CLASS_DELETED: "Class data deleted Successfully",
  CLASS_SUBJECT_ASSIGNED: "Class and Subject are assigned Successfully for",
  CLASS_UPDATED: "Class Updated Successfully!",
  EVIDENCE_DELETED: "Evidence Deleted Successfully",
  FILES_UPLOADED: "Files Uploaded Successfully!",
  INVITATION_DELETED: "Invitation Deleted Successfully",
  IMPORT_SUCCESS: "Import in progress, You'll be intimated once it is completed by email",
  MARK_UPDATED: "Marks Updated successfully",
  PASSWORD_UPDATED: "Password Updated Successfully!",
  PROFILE_UPDATED: "Profile Updated Successfully!",
  PUPIL_DELETED_SUCCESSFULLY: "Pupil Deleted Successfully!",
  PUPIL_IMPORT_CANCELLED: "Pupils import cancelled",
  PUPIL_ACADEMICDETAILS_UPDATED: "Pupils academic details updated!",
  PUPIL_MOVED_SUCCESSFULLY: "Pupil Moved Successfully",
  PUPIL_UPDATED_SUCCESSFULLY: "Pupil Updated Successfully!",
  PUPILS_UPLOADED: "Pupils Uploaded Successfully",
  REPORT_SAVED: "Report Saved Successfully",
  REMOVE_ASSIGNED_CLASS: "Assigned class and subject combinations are removed for",
  ROLE_ASSIGNED: "Role is updated for",
  SCHOOL_CREATED: "School Created Successfully!",
  SCHOOL_UPDATED: "School Updated Successfully!",
  TEACHER_DATA_SUBMITTED: "Teachers data submitted",
  USER_DELETED: "User Deleted Successfully",
  USER_INVITED: "Successfully user is invited",
}

const TERMSCONDITIONS = {
  TC: "I have read and accept the terms and conditions for use of Mappix.",
}

const WARNING = {
  MarkingData: "Marking Data get erased please check",
  REMOVE_SUBJECT: "Are you sure you’d like to remove this subject",
  REMOVE_GENERAL_COMMENT: "Are you sure you’d like to delete this general Comment?",
  RESET_REPORT: "Are you sure you’d like to reset this report?",
}

export { MESSAGES, VALIDATION, ERROR, SUCCESS, TERMSCONDITIONS, WARNING };